import { expedienteServicioService } from "@/_services";
export const expedienteServicio = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
    patch: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getExpedientesServiciosRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getExpedientesServiciosSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getExpedientesServiciosError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    postExpedienteServicioRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postExpedienteServicioError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postExpedienteServicioSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    getExpedienteServicioByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getExpedienteServicioByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getExpedienteServicioByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelSuccess(state, pdf) {
      state.excel.data = pdf;
      state.excel.status = {
        downloaded: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
    putExpedienteServicioRequest(state) {
      state.patch.status = {
        changing: true,
      };
    },
    putExpedienteServicioSuccess(state, response) {
      state.patch.data = response;
      state.patch.status = {
        changed: true,
      };
    },
    putExpedienteServicioError(state, error) {
      state.patch.data = null;
      state.patch.status = {
        error,
      };
    },
  },
  actions: {
    getExpedientesServicios({ commit }, request) {
      commit("getExpedientesServiciosRequest");
      expedienteServicioService
        .getExpedientesServicios(request.pagination, request.filters)
        .then((response) => {
          commit("getExpedientesServiciosSuccess", response);
        })
        .catch((error) => {
          commit("getExpedientesServiciosError", error);
        });
    },
    postExpedienteServicio({ commit }, request) {
      commit("postExpedienteServicioRequest");
      expedienteServicioService
        .postExpedienteServicio(request)
        .then((res) => {
          commit("postExpedienteServicioSuccess", res);
        })
        .catch((error) => {
          commit("postExpedienteServicioError", error);
        });
    },
    getExpedienteServicioById({ commit }, id) {
      commit("getExpedienteServicioByIdRequest");
      expedienteServicioService
        .getExpedienteServicioById(id)
        .then((res) => {
          commit("getExpedienteServicioByIdSuccess", res);
        })
        .catch((error) => {
          commit("getExpedienteServicioByIdError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("excelRequest");
      expedienteServicioService
        .getExcel(filters)
        .then((excel) => {
          commit("excelSuccess", excel);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
    putExpedienteServicio({ commit }, request) {
      commit("putExpedienteServicioRequest");
      expedienteServicioService
        .putExpedienteServicio(request.id, request.body)
        .then((res) => {
          commit("putExpedienteServicioSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteServicioError", error);
        });
    },
  },
};
